import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import * as React from "react";

type AccordionBaseProps = {
  title: string;
  count: number;
  panelId: string;
  stats?: {
    offToday?: number;
    handoversToday?: number;
    offTomorrow?: number;
    handoversTomorrow?: number;
  };
  children: React.ReactNode;
  className?: string;
  defaultExpanded?: boolean;
  classes?: {
    counter?: string;
  };
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
};

export const AccordionBase: React.FC<AccordionBaseProps> = ({
  title,
  count,
  panelId,
  children,
  className = "!bg-primary-50 border-primary-200",
  classes = {
    counter: "bg-primary-100 border-primary-300",
  },
  defaultExpanded = false,
  expanded,
  onChange,
}) => {
  const isEmpty = count === 0;

  const value = expanded !== undefined ? (expanded ? panelId : "") : undefined;
  const defaultValue = defaultExpanded ? panelId : undefined;

  return (
    <Accordion
      type="single"
      collapsible
      value={value}
      defaultValue={defaultValue}
      onValueChange={(val) => onChange?.(val === panelId)}
      disabled={isEmpty}
      className={`rounded-[6px] border border-solid p-2 ${className}`}
    >
      <AccordionItem value={panelId} className="border-b-0">
        <AccordionTrigger
          className="min-h-0 px-2 py-1.5 hover:no-underline"
          disabled={isEmpty}
          aria-controls={`${panelId}-content`}
          id={`${panelId}-header`}
        >
          <div className="flex items-center gap-2">
            <span className="text-sm font-bold">{title}</span>
            <div
              className={`flex h-[18px] min-w-[18px] items-center justify-center rounded-md border border-solid px-[3px] text-[10px] font-bold ${classes.counter}`}
            >
              {count}
            </div>
          </div>
        </AccordionTrigger>
        <AccordionContent className="overflow-visible px-0 pt-0 pb-0">{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
